export default __webpack_public_path__ + "static/media/640_dummy2016-cafe01-de.234703e4.png";